import type Path from "@core/FileProvider/Path/Path";
import type { ResourceError } from "@core-ui/ContextServices/ResourceService/errors";
import ResourceService from "@core-ui/ContextServices/ResourceService/ResourceService";
import { openFilePreview } from "@ext/markdown/elements/file/edit/logic/openFilePreview";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";

interface NameProps {
	path: Path;
	openInSupportedApp: () => void;
	downloadResource: () => void;
	onError: (error: ResourceError | null) => void;
}

const Name = ({ path, downloadResource, onError, openInSupportedApp }: NameProps) => {
	const resourceService = ResourceService.value;
	const openPreview = async () => {
		const data = await resourceService.getResource(path.value);
		if (data.error) return onError(data.error);
		if (!data.buffer) return onError(null);

		openFilePreview(data.buffer, path, {
			onError: () => onError(data.error),
			openInSupportedApp,
			downloadResource,
		});
	};

	return (
		<GlassToolbarButton
			aria-label={path.nameWithExtension}
			className="min-w-0 flex-1 justify-start"
			onClick={openPreview}
		>
			<GlassToolbarIcon className="shrink-0" icon="file" />
			<TextOverflowTooltip className="min-w-0 text-xs">{path.nameWithExtension}</TextOverflowTooltip>
		</GlassToolbarButton>
	);
};

export default Name;
